import { render, staticRenderFns } from "./ReturnsShipping.vue?vue&type=template&id=c3e5087a&"
import script from "./ReturnsShipping.vue?vue&type=script&lang=js&"
export * from "./ReturnsShipping.vue?vue&type=script&lang=js&"
import style0 from "./ReturnsShipping.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports